import { FormGroup, ValidatorFn, AbstractControl } from "@angular/forms";
import { MessageType } from "../../enums/shared/enums";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { FormControlType } from "../../../components/shared/components/dynamic-form/enums";

export class WtfUtils {
    public static filterArrayByString(mainArr, searchText) {
        if (searchText === "") {
            return mainArr;
        }

        searchText = searchText.toLowerCase();

        return mainArr.filter((itemObj) => {
            return this.searchInObj(itemObj, searchText);
        });
    }

    public static searchInObj(itemObj, searchText) {
        for (const prop in itemObj) {
            if (!itemObj.hasOwnProperty(prop)) {
                continue;
            }

            const value = itemObj[prop];

            if (typeof value === "string") {
                if (this.searchInString(value, searchText)) {
                    return true;
                }
            } else if (Array.isArray(value)) {
                if (this.searchInArray(value, searchText)) {
                    return true;
                }
            }

            if (typeof value === "object") {
                if (this.searchInObj(value, searchText)) {
                    return true;
                }
            }
        }
    }

    public static searchInArray(arr, searchText) {
        for (const value of arr) {
            if (typeof value === "string") {
                if (this.searchInString(value, searchText)) {
                    return true;
                }
            }

            if (typeof value === "object") {
                if (this.searchInObj(value, searchText)) {
                    return true;
                }
            }
        }
    }

    public static searchInString(value, searchText) {
        return value.toLowerCase().includes(searchText);
    }

    public static generateGUID() {
        function S4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return S4() + S4();
    }

    public static toggleInArray(item, array) {
        if (array.indexOf(item) === -1) {
            array.push(item);
        } else {
            array.splice(array.indexOf(item), 1);
        }
    }

    public static handleize(text) {
        return text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "-") // Replace spaces with -
            .replace(/[^\w\-]+/g, "") // Remove all non-word chars
            .replace(/\-\-+/g, "-") // Replace multiple - with single -
            .replace(/^-+/, "") // Trim - from start of text
            .replace(/-+$/, ""); // Trim - from end of text
    }

    public static formErrorsToString(form: FormGroup): string {
        let result = "";

        form.errors.forEach((key) => {
            result += "\n" + form.errors[key];
        });

        return result;
    }

    public static showMessage(
        title: string,
        message: string,
        type: MessageType,
        showCancelButton: boolean,
        confirmButtonText: string,
        cancelButtonText: string,
        okCallback: () => void,
        cancelCallback: () => void
    ) {
        const confirmColors: Array<string> = [
            "#00cc99",
            "#E63711",
            "#ff9900",
            "#E63711",
            "#E63711",
        ];
        let messageType: SweetAlertIcon = "success";

        switch (type) {
            case MessageType.error:
                messageType = "error";
                break;
            case MessageType.info:
                messageType = "info";
                break;
            case MessageType.question:
                messageType = "question";
                break;
            case MessageType.warning:
                messageType = "warning";
                break;
        }

        Swal.fire({
            title: title,
            text: message,
            icon: messageType,
            showCancelButton: showCancelButton,
            confirmButtonColor: confirmColors[type],
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
        }).then((result) => {
            if (result.value && okCallback) {
                okCallback();
            } else if (
                result.dismiss === Swal.DismissReason.cancel &&
                cancelCallback
            ) {
                cancelCallback();
            }
        });
    }

    public static getControlTypeName(type): string {
        switch (type) {
            case 3:
                return "Autocomplete";
            case 9:
                return "Checkbox";
            case 5:
                return "Date";
            case 1:
                return "Number";
            case 6:
                return "Object";
            case 4:
                return "Radio Button";
            case 2:
                return "Combobox";
            case 8:
                return "Table";
            case 0:
                return "Text";
            case 7:
                return "Text";
            default:
                return "";
        }
    }

    public static conditionalValidator(
        condition: () => boolean,
        validator: ValidatorFn
    ): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!condition()) {
                return null;
            }
            return validator(control);
        };
    }
}
